import { PublicPurchaseMotionCTA } from 'purchase-motions-components/components/PublicPurchaseMotionCTA/PublicPurchaseMotionCTA';
import { getNonMerchandiseIdProduct } from 'purchase-motions-components/utils/productIdentifier';
import { isPublicNavItem } from '../types/PublicNavItem';
import { getBrowserLocale, getOverrideLocaleParam } from '../utils/getPreferredLanguage';
import { trackPurchaseMotionClick } from '../utils/tracking';
import { withOverrideLocaleDisablePM } from './withOverrideLocaleDisablePM';

/*
 * The advanced purchase-request shape accepted by the touchless buy button.
 * Pulled off the library's own CTA prop type so it stays in sync with
 * RequestedProductV2 without importing the package's internal generated path.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const PublicPurchaseMotionCTAWrapperBase = ({
  purchaseMotion,
  trackingData,
  productApiName,
  displayIndex,
  disabled,
  children,
  uiButtonProps,
  currencyCode,
  paymentTerm,
  commitmentTerm,
  eligibleTreatments,
  purchaseRequest: purchaseRequestFromProps,
  onClick,
  nonMerchandiseIdIdentifier
}) => {
  const trackingSource = trackingData.source;
  const nonMerchandiseIdProduct = getNonMerchandiseIdProduct(productApiName);
  const buttonVariant = displayIndex === 0 ? 'primary' : 'secondary';
  const purchaseRequest = purchaseRequestFromProps !== null && purchaseRequestFromProps !== void 0 ? purchaseRequestFromProps : {
    products: [{
      productApiName,
      skuQuantity: 1
    }],
    quantityPacks: [],
    currencyCode,
    commitmentTerm,
    paymentTerm
  };
  const productNames = purchaseRequest.products.map(p => p.productApiName);
  const browserLocale = getOverrideLocaleParam() ? getBrowserLocale() : undefined;
  return /*#__PURE__*/_jsx(PublicPurchaseMotionCTA, {
    "data-selenium-id": `${trackingSource}-${nonMerchandiseIdIdentifier !== null && nonMerchandiseIdIdentifier !== void 0 ? nonMerchandiseIdIdentifier : nonMerchandiseIdProduct}-${String(purchaseMotion)}-button`,
    apiName: productApiName,
    trackingData: Object.assign({}, trackingData, {
      source: trackingSource,
      uniqueId: trackingData.uniqueId || 'pricing-hero'
    }),
    onClick: () => {
      trackPurchaseMotionClick({
        productApiName,
        purchaseMotion: String(purchaseMotion),
        activeCurrencyCode: String(currencyCode),
        productNames,
        screen: isPublicNavItem(trackingData.screen) ? trackingData.screen : undefined,
        subscreen: trackingData.subscreen,
        trackingSource
      });
      onClick === null || onClick === void 0 || onClick();
    },
    uiButtonProps: Object.assign({
      disabled: disabled !== null && disabled !== void 0 ? disabled : false,
      use: buttonVariant,
      block: true,
      truncate: true
    }, uiButtonProps),
    purchaseMotion: purchaseMotion,
    ctaProps: {
      purchaseRequest,
      eligibleTreatments: eligibleTreatments !== null && eligibleTreatments !== void 0 ? eligibleTreatments : [],
      browserLocale
    },
    children: children
  });
};
export const PublicPurchaseMotionCTAWrapper = withOverrideLocaleDisablePM(PublicPurchaseMotionCTAWrapperBase);